// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"c00673a2","226":"006da318","247":"45e46feb","327":"aa554a79","336":"6071989b","795":"8de511b8","806":"9bccfbbb"}[chunkId] + ".chunk.js";
};